import styled from 'styled-components'

export const Text = styled.p<{ isSmall: boolean; }>`
    color: rgba(255, 66, 94, 1);
    font-weight: 500;
    font-style: normal;
    letter-spacing: 0px;
    font-size: ${({ isSmall }) => isSmall ? '12px' : '14px'};
`
